import { Mobile, Pc } from '../../hooks/MediaQuery'
import Page1Pc from './Page1Pc'
import Page1Mobile from './Page1Mobile'
import { useEffect, useState } from 'react'
import { selectMainBannerList } from '../../api/x_banner'

function Page1() {
  const [banner, setBanner] = useState([])
  useEffect(() => {
    async function fetchBanner() {
      const response = await selectMainBannerList({ code: 'BANNER_02',useYn:'Y' })
      debugger
      const data = response.data.data
      setBanner(data)
    }
    fetchBanner()
  }, [])
  return (
    <>
      <Pc>
        <Page1Pc banner={banner} />
      </Pc>
      <Mobile>
        <Page1Mobile banner={banner} />
      </Mobile>
    </>
  )
}

export default Page1
